// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2c8c17b4","37":"e3777a90","55":"116202fa","171":"6e025fcc","769":"e7e32f19"}[chunkId] + ".chunk.js";
};